<script>
import {useForm} from "@inertiajs/vue3";
import Modal from '@vvg/forum/vue/components/modal.vue';
import Textarea from '@vvg/forum/vue/components/form/textarea.vue';
import FormElements from '@vvg/forum/js/mixins/formElements.js'
import Ajax from '@vvg/forum/js/mixins/ajax.js'
export default {
	components: {Modal, Textarea},
	mixins: [FormElements, Ajax],
	emits: ['save:forum'],

	data() {
		return {
			forum: null,
			form: useForm({
				id: null,
				title: '',
				intro: '',
				overview_image: null,
			})
		}
	},
	methods: {
		open(forum) {
			this.forum = forum;

			if (forum) {
				this.form.defaults(forum);
				this.form.reset();
			} else {
				this.form.defaults({
					id: null,
					title: '',
					intro: '',
					overview_image: null,
				});
				this.form.reset();
			}

			this.$refs.forumModal.open();
		},
		submit() {
			this.submitForm(this.$page.props.forum_url + 'save_forums/' + (this.form.id ? this.form.id + '/' : ''), 'POST', this.form).done(() => {
				this.showToast('Rubriek opgeslagen!');
				this.$emit('save:forum');
				this.$refs.forumModal.close();
			});
		}
	}
}
</script>

<template>
	<Modal :title="'Rubriek ' + (this.forum?.id != null ? 'bewerken' : 'toevoegen')" id="forumModal" ref="forumModal" size="lg">
		<form @submit.prevent="submit()" id="forumModalForm">

			<Input
				type="text"
				label="Titel"
				v-model="form.title"
				name="title"
				:form="form"
				required
			/>
			<CkEditor
				label="Intro"
				v-model="form.intro"
				name="intro"
				:form="form"
				:rows="4"
			/>
			<Asset
				label="Overzicht afbeelding"
				v-model="form.overview_image"
				name="overview_image"
				:form="form"
				:asset="forum?.overview_image"
			/>
		</form>
		<template #footer>
			<span role="button" @click="this.$refs.forumModal.close()" class="btn btn-secondary">Annuleren</span>
			<button type="submit" form="forumModalForm" class="btn btn-primary">Opslaan</button>
		</template>
	</Modal>
</template>
